import { useCallback, useEffect, useRef, useState } from 'react'
import { useSetState, useUpdateEffect } from 'ahooks'
import { SAlert, SDrawerOrModal, SLowcodeList, STableActions } from 'shj-components'
import { Checkbox, Tree } from 'antd'
import { packModelSkuSave } from '@/services/product.ts'
import { cloneDeep, isEmpty } from 'lodash-es'
import styles from '@/pages/baseProduct/packageTemplate/addOrEdit/index.module.less'
import { treeToOneArr } from '@/common/utils.ts'
import {
  findAndModifyTreeNode,
  traverseTree,
} from '@/pages/baseProduct/packageTemplate/addOrEdit/steps/utils.ts'
import { ExclamationCircleFilled } from '@ant-design/icons'
import _ from 'lodash'
import { budgetForAllSpecialCode, budgetForSpecialCode } from '@/services/order'
import ConfigCheck from '../components/ConfigCheck'

const StepPackageSKU = props => {
  const { columnsConfig = [], cacheId, skuData = [], treeData = [], baseInfo } = props
  const listRef = useRef()
  const configRef = useRef()
  const [initFlag, setInitFlag] = useState(true)
  const [state, setState] = useSetState<any>({
    visible: false,
    isSelAll: false, // 全选
    record: {},
    config: { fieldControl: false, rowSelection: false, columns: [], search: false },
    checkedKeys: [],
    configVisble: false,
    allConfigList: [],
    defaultCheckList: [],
    allDefaultCheckObj: {},
  })
  useEffect(() => {
    getAllConfigList()
  }, [])

  const getAllConfigList = async () => {
    try {
      // 所有枚举
      const allListResult: any = await budgetForSpecialCode({})
      // 所有报价类型对应的默认选项
      const allDefaultCheckObj: any = await budgetForAllSpecialCode({})
      setState({
        allConfigList: [
          ...allListResult.map((el: any) => {
            return {
              ...el,
              label: el.desc,
              value: el.code,
            }
          }),
        ],
        allDefaultCheckObj: allDefaultCheckObj,
      })
    } catch (err) {
      console.log(err)
    }
  }
  useEffect(() => {
    let newArray = skuData.map((item, index) => {
      return {
        ...item,
        ...item.argMap,
      }
    })
    listRef.current?.updateDataSource(newArray, newArray.length)
  }, [skuData])

  useEffect(() => {
    if (columnsConfig.length) {
      const columns = columnsConfig.map(item => {
        return {
          title: item.label,
          dataIndex: [item.argCode, 'valueName'],
          width: 200,
          ellipsis: true,
          render: (text, record) => {
            return text || '不限'
          },
        }
      })
      setState({
        config: {
          ...state.config,
          columns: [
            { title: 'SKU序号', dataIndex: 'id', width: 200 },
            ...columns,
            { dataIndex: '#', title: '操作', render: 'actionRender', width: 120, fixed: 'right' },
          ],
        },
      })
    }
  }, [columnsConfig])

  const onAddOrEdit = useCallback(
    (record: Record<string, any>) => {
      let keys: any = []
      // 判断当前最新打包数据的子级是否全部选中（ 有新增的数据 ）
      if (record.packModelTreeNodeIds?.length) {
        record.packModelTreeNodeIds?.forEach(node => {
          keys.push(node)
          findAndModifyTreeNode(treeData, node, newNode => {
            const children = treeToOneArr(newNode.children)
            keys.push(...children.map(item => item.id))
          })
        })
      }
      keys = Array.from(new Set(keys)) // 去重
      console.log(keys, 'keys')

      setState({
        visible: true,
        record: { ...record },
        checkedKeys: keys,
      })
    },
    [treeData]
  )

  useUpdateEffect(() => {
    if (initFlag) {
      setInitFlag(false)
      clearAllChecked(true)
      return
    } else {
      console.log('treeData树结构变化', treeData)
      clearAllChecked(false)
    }
  }, [baseInfo.treeNodes, baseInfo.skuList])
  const clearAllChecked = initFlag => {
    console.log('是否初始化状态:', initFlag)
    console.log('baseInfo:', baseInfo)
    // 清理树结构勾选状态 预算类型默认全勾选
    const newData = _.cloneDeep(listRef.current?.getDataSource() || [])
    newData.forEach(item => {
      let newTreeNodes = _.cloneDeep(treeData)
      let list = treeToOneArr(newTreeNodes)
      if (item.budgetType.valueId == '2') {
        // 预算类型 默认重置为全部勾选
        item.packModelTreeNodeIds =
          !initFlag || !baseInfo.id ? list?.map(item => item.id) : item.packModelTreeNodeIds
      } else {
        item.packModelTreeNodeIds = initFlag
          ? baseInfo.id
            ? item.packModelTreeNodeIds
            : []
          : // : list?.map(item => item.id)
            [] // 初始化状态默认全选 编辑时进来选中自身数据
      }
      handleConfigCheck(item, initFlag)
    })
    listRef.current?.updateDataSource(newData, newData.length)
  }
  // 处理功能配置默认勾选
  const handleConfigCheck = (item: any, initFlag: boolean) => {
    console.log('处理功能配置默认勾选', item, initFlag, state)
    if (initFlag) {
      item.featureConfigurationList =
        item.featureConfigurationList && baseInfo.id
          ? item.featureConfigurationList
          : state.allDefaultCheckObj[item.budgetType.valueCode]
    } else {
      item.featureConfigurationList = state.allDefaultCheckObj[item.budgetType.valueCode]
    }
    return item
  }
  const onSubmit = () => {
    const data_ = listRef.current?.getDataSource() || []
    const trees = cloneDeep(treeData)
    traverseTree(trees, node => (node.isChecked = state.checkedKeys.includes(node.id)))
    console.log(trees, state.checkedKeys)
    findAndModifyTreeNode(data_, state.record.id, node => {
      node.skuDynJson = { ...node.skuDynJson, allowTrees: [...(trees || {})] }
      node.packModelTreeNodeIds = state.checkedKeys // 选中树id值
    })
    listRef.current?.updateDataSource(data_, data_.length)
    setState({ visible: false, record: {} })
  }
  const onConfigNode = (record: any) => {
    console.log('功能配置', record)
    setState({ configVisble: true, record: { ...record } })
    const checkedList = record.featureConfigurationList?.map(item => item.code)
    console.log('功能配置默认勾选', checkedList)
    setState({
      defaultCheckList: checkedList,
    })
    // }
  }
  // 功能配置 提交
  const onConfigSave = () => {
    let checkList = configRef?.current?.getCheckedList
    let submitList = state.allConfigList.filter(item => checkList.includes(item.code))
    submitList = submitList.map(item => {
      return {
        code: item.code,
        desc: item.desc,
      }
    })
    const data_ = listRef.current?.getDataSource() || []
    findAndModifyTreeNode(data_, state.record.id, node => {
      node.featureConfigurationList = submitList
    })
    listRef.current?.updateDataSource(data_, data_.length)
    console.log(data_, 'data数据')
    setState({ configVisble: false, record: {} })
  }
  const extensions = {
    // request: {fetchList},
    customRender: {
      actionRender(_: null, record: Record<string, any>): JSX.Element {
        return (
          <STableActions>
            <STableActions.SActionBtn onClick={() => onAddOrEdit(record)}>
              打包
            </STableActions.SActionBtn>
            <STableActions.SActionBtn onClick={() => onConfigNode(record)}>
              功能配置
            </STableActions.SActionBtn>
          </STableActions>
        )
      },
    },
  }

  const onFinish = (): Promise<any> => {
    return new Promise((resolve, reject) => {
      let skuData = listRef.current?.getDataSource() || []
      resolve(skuData)
    })
  }

  if (props.editRef) props.editRef.onFinish = onFinish

  const onCheck = checkedKeys => {
    setState({ checkedKeys })
  }

  const treeNodeRender = (list: any[]) => {
    return list?.map(item => {
      const name = item?.dtlName || item.title
      return (
        <Tree.TreeNode key={item.id} parent={item.parentIds} value={item.id} title={name}>
          {treeNodeRender(item.children)}
        </Tree.TreeNode>
      )
    })
  }

  return (
    <>
      <div className={styles.edit_wrap}>
        {/* <div className={styles.tooltip_box} style={{ marginLeft: '0' }}>
          <ExclamationCircleFilled style={{ color: 'orange' }} />{' '}
        </div> */}
        <SAlert type="info">
          以下为该模板SKU列表，点击打包可进行SKU打包，若已设置打包，返回修改产品打包，当前设置重置！
        </SAlert>
        <SLowcodeList searchMode={'group'} ref={listRef} config={state.config} {...extensions} />
        <SDrawerOrModal
          width={600}
          title={'打包'}
          onCancel={() => setState({ visible: false })}
          onOk={onSubmit}
          open={state.visible}
        >
          {state.visible && (
            <div>
              <Tree
                defaultExpandAll={treeData?.length}
                checkable
                checkedKeys={state.checkedKeys || [0]}
                onCheck={onCheck}
                // checkStrictly
              >
                {treeNodeRender([{ title: '全选', key: '0', id: '0', children: treeData }])}
              </Tree>
            </div>
          )}
        </SDrawerOrModal>
        {/* 功能配置 */}
        <SDrawerOrModal
          width={600}
          title={'功能配置'}
          onCancel={() => setState({ configVisble: false })}
          onOk={onConfigSave}
          open={state.configVisble}
        >
          {state.configVisble && (
            <ConfigCheck
              list={state.allConfigList}
              defaultCheckList={state.defaultCheckList}
              ref={configRef}
            ></ConfigCheck>
          )}
        </SDrawerOrModal>
      </div>
    </>
  )
}

export default StepPackageSKU
